<template>
  <el-form
    ref="customerForm"
    :model="model"
    :rules="rules"
    label-width="11em"
    label-position="left"
    class="customer-form"
  >
    <div class="el-form--inline">
      <CustomerCode v-model="customerCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autofocus="!editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
      <Blank />
    </div>
    <CustomerName v-model="customerName" :required="!searchMode" :searchCond="searchMode"
      :autocomplete-list="autocompleteCustomerNameSet" />
    <div class="el-form--inline">
      <PostalCode v-model="postalCode" :required="!searchMode" :searchCond="searchMode" />
      <PhoneNumber v-model="phoneNumber" :required="!searchMode" :searchCond="searchMode" />
    </div>
    <StreetAddress v-model="streetAddress" :required="!searchMode" :searchCond="searchMode" />
    <el-divider />
    <InvoiceAddress v-model="invoiceAddress" :required="!searchMode" :searchCond="searchMode" />
    <div class="el-form--inline">
      <!-- <BillingDay v-model="billingDay" :required="!searchMode" :searchCond="searchMode" /> -->
      <Date v-model="billingDay" label="請求日" prop="billing_day" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
      <!-- <TransferDay v-model="transferDay" :required="!searchMode" :searchCond="searchMode" /> -->
      <Date v-model="transferDay" label="振込日" prop="transfer_day" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
    </div>
    <div class="el-form--inline">
      <InvoiceType v-model="invoiceType" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
      <EmailTarget v-model="emailTarget" label="メール送信対象" prop="email_target" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
    </div>
    <div class="el-form--inline">
      <BillingExclusion v-model="billingExclusionFlag" label="停留料除外" prop="billing_exclusion_flag" :searchCond="searchMode" :initialize="true"
        placeholder="請求除外時のみ選択" :clearable="true" codeId="BILLING_EXCLUSION_DEP"/>
      <Blank />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <PrivateId v-model="privateId" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
      <OwnerType v-model="ownerType" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
    </div>
  </el-form>
</template>

<script>
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import CustomerName from '@/components/molecules/form/autocomplete/CustomerName.vue'
import PrivateId from '@/components/molecules/form/select/PrivateId.vue'
import InvoiceAddress from '@/components/molecules/form/textarea/InvoiceAddress.vue'
import PostalCode from '@/components/molecules/form/text/PostalCode.vue'
import StreetAddress from '@/components/molecules/form/textarea/StreetAddress.vue'
import PhoneNumber from '@/components/molecules/form/text/PhoneNumber.vue'
import OwnerType from '@/components/molecules/form/select/OwnerType.vue'
// import BillingDay from '@/components/molecules/form/number/BillingDay.vue'
// import TransferDay from '@/components/molecules/form/number/TransferDay.vue'
import InvoiceType from '@/components/molecules/form/select/InvoiceType.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
import Date from '@/components/molecules/form/select/Date.vue'
import BillingExclusion from '@/components/molecules/form/select/BillingExclusion.vue'
import EmailTarget from '@/components/molecules/form/select/EmailTarget.vue'

export default {
  components: {
    CustomerCode,
    BillingExclusion,
    EmailTarget,
    CustomerName,
    PrivateId,
    InvoiceAddress,
    PostalCode,
    StreetAddress,
    PhoneNumber,
    OwnerType,
    // BillingDay,
    // TransferDay,
    InvoiceType,
    Blank,
    Date
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerNameSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  computed: {
    customerCode: {
      get () {
        return this.model.customer_code
      },
      set (customerCode) {
        const form = { ...this.model }
        form.customer_code = customerCode
        this.$emit('input', form)
      }
    },
    billingExclusionFlag: {
      get () {
        return this.model.billing_exclusion_flag
      },
      set (billingExclusionFlag) {
        // 請求除外が空欄の場合undefinedを格納
        if (billingExclusionFlag === '') {
          billingExclusionFlag = undefined
        }
        const form = { ...this.model }
        form.billing_exclusion_flag = billingExclusionFlag
        this.$emit('input', form)
      }
    },
    emailTarget: {
      get () {
        return this.model.email_target
      },
      set (emailTarget) {
        const form = { ...this.model }
        form.email_target = emailTarget
        this.$emit('input', form)
      }
    },
    customerName: {
      get () {
        return this.model.customer_name
      },
      set (customerName) {
        const form = { ...this.model }
        form.customer_name = customerName
        this.$emit('input', form)
      }
    },
    privateId: {
      get () {
        return this.model.private_id
      },
      set (privateId) {
        const form = { ...this.model }
        form.private_id = privateId
        this.$emit('input', form)
      }
    },
    invoiceAddress: {
      get () {
        return this.model.invoice_address
      },
      set (invoiceAddress) {
        const form = { ...this.model }
        form.invoice_address = invoiceAddress
        this.$emit('input', form)
      }
    },
    postalCode: {
      get () {
        return this.model.postal_code
      },
      set (postalCode) {
        const form = { ...this.model }
        form.postal_code = postalCode
        this.$emit('input', form)
      }
    },
    streetAddress: {
      get () {
        return this.model.street_address
      },
      set (streetAddress) {
        const form = { ...this.model }
        form.street_address = streetAddress
        this.$emit('input', form)
      }
    },
    phoneNumber: {
      get () {
        return this.model.phone_number
      },
      set (phoneNumber) {
        const form = { ...this.model }
        form.phone_number = phoneNumber
        this.$emit('input', form)
      }
    },
    ownerType: {
      get () {
        return this.model.owner_type
      },
      set (ownerType) {
        const form = { ...this.model }
        form.owner_type = ownerType
        this.$emit('input', form)
      }
    },
    billingDay: {
      get () {
        return this.model.billing_day
      },
      set (billingDay) {
        const form = { ...this.model }
        form.billing_day = billingDay
        this.$emit('input', form)
      }
    },
    transferDay: {
      get () {
        return this.model.transfer_day
      },
      set (transferDay) {
        const form = { ...this.model }
        form.transfer_day = transferDay
        this.$emit('input', form)
      }
    },
    invoiceType: {
      get () {
        return this.model.invoice_type
      },
      set (invoiceType) {
        const form = { ...this.model }
        form.invoice_type = invoiceType
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.customerForm.resetFields()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.customerForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.customer-form {
  .el-form-item.customer-name{
    .el-input__inner{
      width: 49em;
    }
  }
}
</style>
